<template>
  <z-page class="toolbar-config">
    <!-- 搜索栏 -->
    <div class="page-search">
      <div class="search-item">
        <div>产品名称：</div>
        <div class="long">
          <el-select
            width
            size="mini"
            v-model="search.productKey"
            @change="getdata()"
            slot="prepend"
            placeholder="请选择"
          >
            <el-option
              v-for="(item,index) in product"
              :key="index"
              :label="item.category_name"
              :value="item.ecsProduct.kfProductKey"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="left">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="功能配置" name="first">
          <div class="left-toolbar">
            <div class="title">
              <span>左侧工具条：</span>
              <el-switch style="float:right;" v-model="left_menu_display"></el-switch>
            </div>
            <div class="item">
              <label>产品一：</label>
              <el-select size="mini" v-model="nowproductIndex[0]" placeholder="请选择">
                <el-option
                  label="空"
                  :value="null"
                ></el-option>
                <el-option
                  v-for="(item, index) in productlist"
                  :key="index"
                  :label="item.name"
                  :value="index"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <label>产品二：</label>
              <el-select size="mini" v-model="nowproductIndex[1]" placeholder="请选择">
                <el-option
                  label="空"
                  :value="null"
                ></el-option>
                <el-option
                  v-for="(item, index) in productlist"
                  :key="index"
                  :label="item.name"
                  :value="index"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <label>产品三：</label>
              <el-select size="mini" v-model="nowproductIndex[2]" placeholder="请选择">
                <el-option
                  label="空"
                  :value="null"
                ></el-option>
                <el-option
                  v-for="(item, index) in productlist"
                  :key="index"
                  :label="item.name"
                  :value="index"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <label>产品四：</label>
              <el-select size="mini" v-model="nowproductIndex[3]" placeholder="请选择">
                <el-option
                  label="空"
                  :value="null"
                ></el-option>
                <el-option
                  v-for="(item, index) in productlist"
                  :key="index"
                  :label="item.name"
                  :value="index"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <label>产品五：</label>
              <el-select size="mini" v-model="nowproductIndex[4]" placeholder="请选择">
                <el-option
                  label="空"
                  :value="null"
                ></el-option>
                <el-option
                  v-for="(item, index) in productlist"
                  :key="index"
                  :label="item.name"
                  :value="index"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <label>产品六：</label>
              <el-select size="mini" v-model="nowproductIndex[5]" placeholder="请选择">
                <el-option
                  label="空"
                  :value="null"
                ></el-option>
                <el-option
                  v-for="(item, index) in productlist"
                  :key="index"
                  :label="item.name"
                  :value="index"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="right-toolbar">
            <div class="title">
              <span>右侧工具条：</span>
              <el-switch style="float:right;" disabled v-model="right_menu_display"></el-switch>
            </div>
            <div class="item">
              <div style="padding-top:20px;">
                <label>显示内容：</label>
                <div class="item-list">
                  <el-checkbox disabled v-model="openproduct[0]">账号</el-checkbox>
                  <el-checkbox disabled v-model="openproduct[1]">充值</el-checkbox>
                  <el-checkbox disabled v-model="openproduct[2]">赚钱</el-checkbox>
                  <el-checkbox v-model="openproduct[3]">开通</el-checkbox>
                  <el-checkbox v-model="openproduct[4]">下载</el-checkbox>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="样式配置" name="second">
          <div class="left-toolbar bigitem">
            <div class="title">
              <span>左侧工具条：</span>
              <el-switch style="float:right;" v-model="left_menu_display"></el-switch>
            </div>
            <div class="item">
              <label>选区背景：</label>
              <el-select size="mini" @change="style_change" v-model="bac_flag" placeholder="请选择">
                <el-option label="默认样式" :value="false"></el-option>
                <el-option label="自定义" :value="true"></el-option>
              </el-select>
              <el-color-picker show-alpha @change="style_change" v-if="bac_flag" size="mini" v-model="bac_color"></el-color-picker>
            </div>
            <div class="item">
              <label>悬浮颜色：</label>
              <el-select size="mini" @change="style_change" v-model="hover_flag" placeholder="请选择">
                <el-option label="默认样式" :value="false"></el-option>
                <el-option label="自定义" :value="true"></el-option>
              </el-select>
              <el-color-picker show-alpha @change="style_change" size="mini" v-if="hover_flag" v-model="hover_color"></el-color-picker>
            </div>
            <div class="item">
              <label>背景颜色：</label>

              <el-select size="mini" @change="style_change" v-model="border_flag" placeholder="请选择">
                <el-option label="默认样式" :value="false"></el-option>
                <el-option label="自定义" :value="true"></el-option>
              </el-select>
              <el-color-picker show-alpha @change="style_change" size="mini" v-if="border_flag" v-model="border_color"></el-color-picker>
            </div>
          </div>
          <div class="left-toolbar" style="margin-top:88px;">
            <div class="title">
              <span>右侧工具条：</span>
              <el-switch style="float:right;" disabled v-model="right_menu_display"></el-switch>
            </div>
            <div class="item">
              <label>样式：</label>
              <el-select size="mini" v-model="right_flag" placeholder="请选择">
                <el-option label="蓝色" :value="false"></el-option>
                <el-option label="黑色" :value="true"></el-option>
              </el-select>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="btns" style="margin-top:60px;">
        <div @click="save()" class="z-btn normal" :class="{disabled:disabled}">保存</div>
        <div @click="getdata()" class="z-btn">取消修改</div>
      </div>
    </div>
    <div class="right">
      <div v-if="condition" class="main">
        <div
          v-if="left_menu_display"
          class="leftbar"
          :style="{background:border_color}"
        >
          <div
            :onMouseOver="getHover"
            :onMouseOut="getOut"
            class="bar-item"
            v-for="(item, index) in getproduct"
            :key="index"
            :style="{background:bac_color}"
            
          >
            <img :src="($url.bar+item.icon_url)||''" alt />
            <br />
            <span>{{item.name}}</span>
          </div>
        </div>
        <div class="rightbar" :class="{blue:!right_flag}">
          <div class="bar-item">
            <img src="@/assets/img/bar/acc.svg" alt />
            <span>账号</span>
          </div>
          <div class="bar-item">
            <img src="@/assets/img/bar/Recharge.svg" alt />
            <span>充值</span>
          </div>
          <div v-if="openproduct[3]" class="bar-item">
            <img src="@/assets/img/bar/Opening.svg" alt />
            <span>开通</span>
          </div>
          <div class="bar-item">
            <img src="@/assets/img/bar/make.svg" alt />
            <span>赚钱</span>
          </div>
          <div v-if="openproduct[4]" class="bar-item">
            <img src="@/assets/img/bar/download.svg" alt />
            <span>下载</span>
          </div>
          <div style="bottom:110px;" class="bottom-item">
            <img src="@/assets/img/bar/Consultation.svg" alt />
          </div>
          <div style="bottom:70px;" class="bottom-item">
            <img src="@/assets/img/bar/phone.svg" alt />
          </div>
        </div>
      </div>
    </div>
  </z-page>
</template>
<script>
export default {
  data() {
    return {
      condition:true,
      bac_color: "#1798FC",
      bac_flag: false,

      hover_color: "#4EB1FD",
      hover_flag: false,

      border_color: "#87C7F9",
      border_flag: false,

      right_flag: false,

      activeName: "first",
      data_list: [],
      total: 0,
      checked: false,
      value1: false,
      search: {
        text_type: "",
        text: "",
        productKey: ""
      },
      nowpage: 1,
      searching: {},
      product: "",
      productlist: [],
      nowproductIndex: [],
      openproduct: [true, true, true],
      left_menu_display: false, //显示左侧侧边栏,
      right_menu_display: true,
      disabled:false
    };
  },
  computed: {
    getOut() {
      
      return 'this.style.background="'+this.bac_color+'"';
    },
    getHover() {
      return 'this.style.background="' + this.hover_color + '"';
    },
    getproduct() {
      let arr = [];
      this.nowproductIndex.map(val => {
        if(this.productlist[val]){
          arr.push(this.productlist[val]);
        }
        
      })
      console.log(arr);
      
      return arr;
    }
  },
  created() {

    this.rgbaTOhex('rgba(1,1,1,0.15)')
    this.$store.dispatch("getproduct").then(res => {
      if (res[0]) {
        this.searching.productKey = res[0].ecsProduct.kfProductKey;
        this.search.productKey = res[0].ecsProduct.kfProductKey;
        this.search.product = res[0].category_name;
        this.searching.product = res[0].category_name;
        this.product = res;
      }
      this.getdata();
    });
  },
  methods: {
    //保存方法
    save() {
      let url = `/api/supplier/tool/bar/operate`;
      let obj = {
        option:'mod',
        comeFrom:this.search.productKey,
        downloadDisplay: this.openproduct[4] ? "1" : "0", //右侧下载按钮
        server_display:this.openproduct[3]? "1" : "0",    //开通按钮
        leftMenuBackground: this.left_menu_display?   (this.bac_flag ? this.rgbaTOhex(this.bac_color)  : "#1798FC00") :null,
        leftMenuBorderColor: this.left_menu_display? (this.border_flag ? this.rgbaTOhex(this.border_color) : "#87C7F999"):null,
        leftMenuHoverColor: this.left_menu_display?(this.hover_flag ? this.rgbaTOhex(this.hover_color)  : "#4EB1FD66"):null, //左侧悬浮颜色
        leftMenuDisplay: this.left_menu_display ? "1" : "0",
        left_menu_item: this.nowproductIndex.join("|"), //左侧工具栏 item
        color:this.right_flag?'black':'blue',
        style:'orange'
      };
      this.$http.post(url,obj)
      .then(res=>{
        if(res.code=='200'){
          this.successTip(res.res_data)
        }
      })
    },
    //左侧工具条样式change
    style_change() {
      this.bac_color = this.bac_flag ? this.bac_color : "#1798FC";
      this.hover_color = this.hover_flag ? this.hover_color : "#4EB1FD";
      this.border_color = this.border_flag ? this.border_color : "#87C7F9";
      
      this.condition=false
      setTimeout(()=>{
        this.condition=true
      },500)
      
    },
    //获取数据方法
    getdata() {
      let url = `/api/supplier/tool/bar/get`; //获取当前样式和各种信息的url
      let newurl = `/api/supplier/get/tool/bar/left/item`; //获取工具条左侧导航栏可选信息接口

      this.$http.get(newurl).then(res => {
        this.productlist = res.res_data;
        this.$http
          .get(url, {
            params: {
              come_from: this.search.productKey
            }
          })
          .then(R => {
            if (R.res_data) {
              this.left_menu_display = R.res_data.left_menu_display == 1;
              this.nowproductIndex = R.res_data.left_menu_item.split("|");
              this.openproduct = [true,true,true, R.res_data.server_display == "1",R.res_data.download_display == "1"];
              this.right_flag= R.res_data.color != 'blue'

              if(R.res_data.left_menu_background){
                this.bac_color=R.res_data.left_menu_background
                this.bac_flag = true;
              }else{
                this.bac_flag = false;
              }


              this.bac_color= this.hexTOrgba(R.res_data.left_menu_background) ||'#1798FC6F'
              this.bac_flag = R.res_data.left_menu_background?true:false

              this.hover_color= this.hexTOrgba(R.res_data.left_menu_hover_color) ||'#1798FC6F'
              this.hover_flag = R.res_data.left_menu_hover_color?true:false

              this.border_color= this.hexTOrgba(R.res_data.left_menu_border_color) ||'#1798FC6F'
              this.border_flag = R.res_data.left_menu_border_color?true:false
              this.disabled=false
              
            } else {
              this.left_menu_display = false;
              this.nowproductIndex = ["1", "2", "3", "4", "5", "6"];
              this.openproduct = [true, true, true, false, false];
              this.bac_flag = false;
              this.hover_flag = false;
              this.border_flag = false;
              this.right_flag = false
              this.disabled=true
            }
          });
      });
    },
    rgbaTOhex(color){
      if(!color){
        return null
      }
        var rgb = color.split(',');
        let a = parseInt(rgb[3].split(')')[0]*256)-1
        if(a==-1){
          a=0
        }
        let aa
        if(a.toString(16).length==1){
          aa= '0'+a.toString(16)
        }else{
          aa = a.toString(16)
        }
    var r = parseInt(rgb[0].split('(')[1]);
    var g = parseInt(rgb[1]);
    var b = parseInt(rgb[2]);
    var hex = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1) +aa;
  
    return hex;
    },
    hexTOrgba(hex){
      if(!hex){
        return null
      }
     let  a = hex.slice(-2)
     var RGBA = "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt( "0x" + hex.slice(5, 7)) +',' +(parseInt("0x" + a)/256).toFixed(2) + ")";
      return RGBA
    },
    // 导航切换方法
    handleClick(tab, event) {
      // console.log(tab, event);
    }
  }
};
</script>
<style lang="less" scoped>
.toolbar-config {
  .left,
  .right {
    display: inline-block;
    width: 60%;
    /deep/ .el-tabs__active-bar {
      padding: 0;
      width: 88px !important;
    }
    /deep/ .el-tabs__item {
      &:last-child {
        padding-left: 20px;
        width: 108px;
      }
      padding: 0;
      width: 88px;
      text-align: center;
      font-size: 14px;
    }
  }
  .right {
    float: right;
    padding: 20px;
    .main {
      height: 666px;
      width: 630px;
      background-image: url(/menu-icon/bac.png);
      display: flex;
      display: -webkit-flex;
      align-items: center;
      justify-content: space-between;
      .blue {
        background: rgba(31, 60, 128, 1) !important;
      }
      .leftbar {
        padding: 2px 2px 8px 2px;
        width: 74px;
        background: rgba(0, 0, 0, 0.8);
        border-radius: 0px 4px 4px 0px;
        border: #fff 1px solid;
        .bar-item {
          width: 64px;
          height: 64px;
          text-align: center;
          margin-left: 2px;
          margin-top: 2px;
          transition: .3s;
          img {
            margin-top: 10px;
            width: 28px;
            height: 28px;
          }
          span {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFangSC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 12px;
          }
        }
      }
      .rightbar {
        margin-left: auto;
        margin-top: 33px;
        width: 40px;
        height: 632px;
        background: #1a1a1a;
        border-radius: 0px 0px 4px 0px;
        position: relative;
        .bottom-item {
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          &:hover {
            background: #0066cc;
          }
          img {
            width: 24px;
            height: 24px;
          }
        }
        .bar-item {
          width: 40px;
          height: 50px;
          display: flex;
          display: -webkit-flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          &:hover {
            background: #0066cc;
          }
          &:first-child {
            margin-top: 48px;
          }
          img {
            width: 20px;
            height: 20px;
            margin-bottom: 6px;
          }
          span {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFangSC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 12px;
          }
        }
      }
    }
  }
  .left {
    width: 40%;
    padding: 20px 10px 0px 10px;
    .left-toolbar {
      padding-top: 24px;
      .title {
        line-height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(16, 30, 56, 1);
        border-block-end: rgba(223, 227, 232, 1) solid 1px;
        padding-bottom: 8px;
      }
      .item {
        height: 40px;
        line-height: 28px;
        padding-top: 16px;
        position: relative;
        /deep/ .el-select {
          float: right;
          width: 240px;
        }
        /deep/ .el-color-picker {
          position: absolute;
          right: 260px;
          top: 17px;
        }
      }
    }
    .right-toolbar {
      padding-top: 60px;
      .title {
        line-height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(16, 30, 56, 1);
        border-block-end: rgba(223, 227, 232, 1) solid 1px;
        padding-bottom: 8px;
      }
      .item-list {
        width: 300px;
        float: right;
        /deep/ .el-checkbox {
          margin-bottom: 10px;
        }
      }
    }
  }
}
.list-head,
.list-item {
  > div {
    &:nth-child(1) {
      width: 16%;
    }
    &:nth-child(2) {
      width: 50%;
    }
    &:nth-child(3),
    &:nth-child(4) {
      width: 17%;
      text-align: center;
    }
  }
}
</style>
